/*
  Product card quick-add variant picker, used by every grid that renders
  product-grid-item (collection, search, related and featured products).

  The trigger button opens a modal (bottom sheet on mobile, centered popup on
  desktop). Picking a variant adds it to cart immediately and closes the modal.
  Submission itself is delegated to the theme's existing
  ajax-add-to-cart(-extra) buttons (kept in the DOM but hidden) so this stays a
  thin listener and doesn't duplicate the <collection-add-to-cart> / mini-cart
  wiring.

  While open, the panel is moved to <body> and put back afterwards: it is
  position: fixed, and any transformed ancestor in the card would otherwise
  become its containing block and break the overlay alignment.
*/
(function () {
  'use strict';

  var TRANSITION_MS = 250;

  var overlay = null;
  var currentPanel = null;

  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'quick-add-overlay';
      overlay.hidden = true;
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function triggerFor(panel) {
    return document.querySelector('[aria-controls="' + panel.id + '"]');
  }

  function returnPanelHome(panel) {
    panel.hidden = true;
    if (panel.quickAddHome) {
      panel.quickAddHome.appendChild(panel);
      panel.quickAddHome = null;
    }
  }

  function openPanel(panel, trigger) {
    if (currentPanel) closePanel({ immediate: true });

    if (!panel.quickAddHome) {
      panel.quickAddHome = panel.parentNode;
      document.body.appendChild(panel);
    }

    var backdrop = getOverlay();
    backdrop.hidden = false;
    panel.hidden = false;
    currentPanel = panel;
    document.body.classList.add('quick-add-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    // Two frames: the first commits the pre-transition state now that the
    // panel is laid out, the second starts the slide/fade in.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        backdrop.classList.add('is-open');
        panel.classList.add('is-open');
      });
    });

    var firstOption = panel.querySelector('.quick-add-option');
    if (firstOption) firstOption.focus({ preventScroll: true });
  }

  function closePanel(options) {
    if (!currentPanel) return;

    var settings = options || {};
    var panel = currentPanel;
    var trigger = triggerFor(panel);
    currentPanel = null;

    panel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('quick-add-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (settings.returnFocus && trigger) trigger.focus({ preventScroll: true });

    if (settings.immediate) {
      if (overlay) overlay.hidden = true;
      returnPanelHome(panel);
      return;
    }

    setTimeout(function () {
      // Skip if this same panel was reopened while the transition ran; only
      // hide the shared overlay once nothing else has claimed it.
      if (currentPanel === panel) return;
      if (overlay && !currentPanel) overlay.hidden = true;
      returnPanelHome(panel);
    }, TRANSITION_MS);
  }

  // Mirrors the single-variant ajax-add-to-cart button: grey out while the
  // request is in flight, flash "Added to Cart" on success, then revert
  // after 1s. updated-mini-cart is a jQuery-only custom event (theme-wide
  // convention, see cart-redesign.js.liquid/tiered-discounts.js.liquid), so
  // it has to be picked up via jQuery, not a native addEventListener.
  function addToCart(trigger, submitButton) {
    var originalText = trigger.textContent;
    trigger.disabled = true;
    trigger.classList.add('disabled');

    var revert = function () {
      trigger.textContent = originalText;
      trigger.disabled = false;
      trigger.classList.remove('disabled');
    };

    function onAdded() {
      clearTimeout(fallbackTimer);
      trigger.textContent = 'Added to Cart';
      setTimeout(revert, 1000);
    }

    var fallbackTimer = setTimeout(function () {
      if (window.jQuery) jQuery(document.body).off('updated-mini-cart', onAdded);
      revert();
    }, 5000);

    if (window.jQuery) jQuery(document.body).one('updated-mini-cart', onAdded);
    submitButton.click();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.quick-add-trigger');
    if (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      if (panel === currentPanel) {
        closePanel({ returnFocus: true });
      } else {
        openPanel(panel, trigger);
      }
      return;
    }

    if (event.target.closest('.quick-add-close')) {
      closePanel({ returnFocus: true });
      return;
    }

    if (!event.target.closest('.quick-add-panel')) {
      closePanel();
    }
  });

  // Clicking a label forwards a synthetic click to its input (skipped by the
  // browser when the input is disabled), so this fires exactly once per
  // pick and never for sold-out options — deliberately not a "change"
  // listener, since re-picking the already-checked option should still add it.
  document.addEventListener('click', function (event) {
    var input = event.target.closest('.quick-add-option-input');
    if (!input) return;

    var panel = input.closest('.quick-add-panel');
    if (!panel) return;

    var trigger = triggerFor(panel);
    var submitButton = panel.querySelector('.ajax-add-to-cart:not(.hide), .ajax-add-to-cart-extra:not(.hide)');
    closePanel();
    if (trigger && submitButton && !submitButton.disabled) addToCart(trigger, submitButton);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanel({ returnFocus: true });
  });
})();
